/*** media-grid-with-modal - Section Scripts ***/

(function () {
  const showMoreSections = document.querySelectorAll('[data-show-more-cards-list]');
  if (showMoreSections && showMoreSections.length) {
    var showMoreSectionsList = Array.from(showMoreSections);
    showMoreSectionsList.map(function (section) {
      const trigger = section.querySelector('[data-show-more-cards-trigger]');

      trigger.addEventListener('click', function () {
        if (section.getAttribute('data-show-more-cards-list') === 'visible') {
          section.setAttribute('data-show-more-cards-list', 'hidden');
        } else {
          section.setAttribute('data-show-more-cards-list', 'visible');
        }
      });
    });
  }
})();
